const LINE_MAX_REPOSITORIES = 2;
/** "owner/name@branch (a1b2c3d, dirty)": owner and name when known, the branch after "@", sha7 and dirtiness in parentheses. */
export function formatRepositoryRef(repository) {
    const name = repository.owner ? `${repository.owner}/${repository.name}` : repository.name;
    const branch = repository.branch ? `@${repository.branch}` : "";
    const state = [];
    if (repository.commit)
        state.push(repository.commit.slice(0, 7));
    if (repository.dirty)
        state.push("dirty");
    return `${name}${branch}${state.length > 0 ? ` (${state.join(", ")})` : ""}`;
}
export function handoverSummary(document) {
    return {
        done: document.done?.length ?? 0,
        todo: document.todo?.length ?? 0,
        verify: document.verify?.length ?? 0,
        ideas: document.ideas?.length ?? 0,
        repositories: (document.repositories ?? []).map(formatRepositoryRef),
    };
}
export function formatHandoverLine(document) {
    const summary = handoverSummary(document);
    const parts = [];
    if (summary.done > 0)
        parts.push(`${summary.done} done`);
    if (summary.todo > 0)
        parts.push(`${summary.todo} to do`);
    if (summary.verify > 0)
        parts.push(`${summary.verify} verify`);
    if (summary.ideas > 0)
        parts.push(`${summary.ideas} ${summary.ideas === 1 ? "idea" : "ideas"}`);
    const shown = summary.repositories.slice(0, LINE_MAX_REPOSITORIES);
    parts.push(...shown);
    const hidden = summary.repositories.length - shown.length;
    if (hidden > 0)
        parts.push(`+${hidden} more`);
    return parts.length > 0 ? parts.join(" · ") : "handover";
}
//# sourceMappingURL=handover.js.map